import { combineReducers } from 'redux';

import auth from './auth';
import app from './app';
import bc from './breadcrumbs';
import segmentsList from './segments_list';
import segmentsView from './segments_view';
import segmentsCompare from './segments_compare';
import clusters from './clusters';
import onboarding from './onboarding';
import users from './users';
import usersEdit from './users_edit';
import rtApiList from './rt_api_list';
import rtApiDemo from './rt_api_demo';
import rtApiUsage from './rt_api_usage';
import modelsList from './models_list';
import modelView from './model_view';
import modelAdd from './model_add';
import modelsCompare from './models_compare';
import copyPx from './copy_px';
import clientsEdit from './clients_edit';

export default combineReducers({
  auth,
  app,
  bc,
  segmentsList,
  segmentsView,
  segmentsCompare,
  clusters,
  onboarding,
  users,
  usersEdit,
  modelsList,
  modelView,
  modelAdd,
  modelsCompare,
  rtApiList,
  rtApiDemo,
  rtApiUsage,
  copyPx,
  clientsEdit,
});
